@if (jobs.savedJobs().length === 0) {
  <app-platform-jobs-empty-state
    [icon]="icons.bookmark"
    [title]="'jobboard.platform.jobs.saved.empty-title' | transloco"
    [text]="'jobboard.platform.jobs.saved.empty-text' | transloco"
    [ctaLabel]="'jobboard.platform.jobs.saved.empty-cta' | transloco"
    [ctaIcon]="icons.search"
    [ctaLink]="['/jobs', 'recommendations']"
  />
} @else {
  <div class="table-wrapper">
    <div class="actions">
      <label class="filter">
        <input
          type="checkbox"
          [checked]="hideApplied()"
          (change)="toggleHideApplied()"
        />
        <span>{{ 'jobboard.platform.jobs.saved.filter-applied' | transloco }}</span>
      </label>
      <label class="filter">
        <input
          type="checkbox"
          [checked]="hideClosed()"
          (change)="toggleHideClosed()"
        />
        <span>{{ 'jobboard.platform.jobs.saved.filter-closed' | transloco }}</span>
      </label>
    </div>
    @if (visibleJobs().length === 0) {
      <ct-lib-empty-placeholder
        [icon]="icons.bookmark"
        [title]="'jobboard.platform.jobs.saved.filter-empty-title' | transloco"
        [text]="'jobboard.platform.jobs.saved.filter-empty-text' | transloco"
      />
    } @else {
      <p-table
        [value]="visibleJobs()"
        dataKey="id"
        [rowTrackBy]="trackById"
        sortField="pinnedAt"
        [sortOrder]="-1"
        [scrollable]="true"
        [scrollHeight]="'flex'"
      >
        <ng-template #header>
          <tr>
            <th pSortableColumn="jobTitle">
              {{ 'jobboard.platform.jobs.table.job' | transloco }}
              <fa-icon class="sort" [icon]="icons.sort"></fa-icon>
              <fa-icon class="sortUp" [icon]="icons.sortUp"></fa-icon>
              <fa-icon class="sortDown" [icon]="icons.sortDown"></fa-icon>
            </th>
            <th pSortableColumn="companyName">
              {{ 'jobboard.platform.jobs.table.company' | transloco }}
              <fa-icon class="sort" [icon]="icons.sort"></fa-icon>
              <fa-icon class="sortUp" [icon]="icons.sortUp"></fa-icon>
              <fa-icon class="sortDown" [icon]="icons.sortDown"></fa-icon>
            </th>
            <th class="d-none d-md-table-cell" pSortableColumn="location">
              {{ 'jobboard.platform.jobs.table.location' | transloco }}
              <fa-icon class="sort" [icon]="icons.sort"></fa-icon>
              <fa-icon class="sortUp" [icon]="icons.sortUp"></fa-icon>
              <fa-icon class="sortDown" [icon]="icons.sortDown"></fa-icon>
            </th>
            <th class="d-none d-lg-table-cell table-date-column" pSortableColumn="pinnedAt">
              {{ 'jobboard.platform.jobs.table.saved-at' | transloco }}
              <fa-icon class="sort" [icon]="icons.sort"></fa-icon>
              <fa-icon class="sortUp" [icon]="icons.sortUp"></fa-icon>
              <fa-icon class="sortDown" [icon]="icons.sortDown"></fa-icon>
            </th>
            <th class="actions">{{ 'jobboard.platform.jobs.table.actions' | transloco }}</th>
          </tr>
        </ng-template>
        <ng-template #body let-savedJob>
          <tr>
            <td>
              <div class="cell-job">
                @if (savedJob.jobUrl || jobs.jobboardJobUrl(savedJob.companyId, savedJob.jobId); as jobUrl) {
                  <a
                    [href]="jobUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                  >{{ savedJob.jobTitle }}</a>
                } @else {
                  <span>{{ savedJob.jobTitle }}</span>
                }
                <div class="tags">
                  @if (savedJob.closed) {
                    <ct-lib-tag [variant]="TagVariant.GRAY">
                      {{ 'jobboard.platform.jobs.saved.closed-tag' | transloco }}
                    </ct-lib-tag>
                  }
                  @if (savedJob.applied) {
                    <ct-lib-tag [variant]="TagVariant.DEFAULT">
                      {{ 'jobboard.platform.jobs.saved.applied-tag' | transloco }}
                    </ct-lib-tag>
                  }
                </div>
              </div>
            </td>
            <td>
              <div class="cell-company">
                @if (jobs.jobboardCompanyUrl(savedJob.companyId); as companyUrl) {
                  <a
                    [href]="companyUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    [attr.aria-label]="'jobboard.platform.jobs.open-company' | transloco"
                  >
                    <app-platform-company-logo
                      [companyName]="savedJob.companyName"
                      [companyId]="savedJob.companyId"
                      [small]="true"
                    />
                    <span>{{ savedJob.companyName }}</span>
                  </a>
                } @else {
                  <app-platform-company-logo
                    [companyName]="savedJob.companyName"
                    [companyId]="savedJob.companyId"
                    [small]="true"
                  />
                  <span>{{ savedJob.companyName }}</span>
                }
              </div>
            </td>
            <td class="d-none d-md-table-cell">{{ savedJob.location }}</td>
            <td class="d-none d-lg-table-cell table-date-column">
              {{ savedJob.pinnedAt | date: 'dd.MM.yyyy' }}
            </td>
            <td class="actions">
              @if (!savedJob.closed) {
                <app-platform-job-apply-menu
                  [applied]="savedJob.applied"
                  [context]="jobs.applyContextFromSavedJob(savedJob)"
                />
              }
              <fa-icon
                [icon]="icons.bookmark"
                size="lg"
                [tooltip]="'jobboard.platform.jobs.saved.unsave-aria' | transloco"
                [attr.aria-label]="'jobboard.platform.jobs.saved.unsave-aria' | transloco"
                (click)="unsave(savedJob)"
              ></fa-icon>
            </td>
          </tr>
        </ng-template>
      </p-table>
    }
  </div>
}
